import React from "react";
import moment from "moment";
import { InputLabel } from "@mui/material";
import { Card, CardBody, Col, Row } from "reactstrap";

import AMultiSelect from "views/pages/manage/common/form-fields-mui/AMultiSelect";
import CustomDatePicker from "views/pages/manage/common/commonComponents/CustomDatePicker";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import { InputLabelStyle } from "views/pages/manage/common/form-fields-mui/ASelect";
import { isFilterApplied } from "../../constant/batch-search";
import { initialFilters, transactionType } from "./constants";
import AAutoComplete from "views/pages/manage/common/form-fields-mui/AAutoComplete";

const BarcodeFilters = ({
  closeForm,
  applyFilter,
  filters,
  filterCount,
  setFilterCount,
  businessAreaOptions,
}) => {
  const [filterForm, setFilterForm] = React.useState(filters);

  const filterFormHandler = (value, key) =>
    setFilterForm((prev) => ({ ...prev, [key]: value }));

  const handleApplyFilter = () => {
    closeForm();
    applyFilter(filterForm);

    const filterCount = isFilterApplied({
      ...filterForm,
    });

    setFilterCount(filterCount);
  };

  return (
    <Card
      className="mb-0 regular-body label-color"
      style={{ width: "330px", borderRadius: "12px" }}
    >
      <CardBody className="d-flex flex-column">
        <div className="text-bold text-lg mb-2">Filters</div>

        <div className="d-flex flex-column gap-md">
          <AAutoComplete
            // height={inputHeight}
            label="Business Area"
            // placeholder="Batch"
            items={businessAreaOptions}
            currentValue={filterForm?.businessAreaList}
            isShowCount={true}
            handleChange={(value) => {
              filterFormHandler(value, "businessAreaList");
            }}
            inputKey="businessAreaList"
          />

          <AAutoComplete
            label="Transaction Type"
            items={transactionType}
            currentValue={filterForm?.transactionTypeList}
            isShowCount={true}
            handleChange={(value) => {
              filterFormHandler(value, "transactionTypeList");
            }}
            inputKey="transactionTypeList"
          />

          <div>
            <InputLabel style={InputLabelStyle}>Transaction Date</InputLabel>
            <Row>
              <Col sm="6">
                <CustomDatePicker
                  placeHolder="From"
                  // minDate={moment()}
                  value={
                    filterForm?.transactionStartDate
                      ? moment(filterForm?.transactionStartDate)
                      : null
                  }
                  handler={(index, date, keyName) => {
                    filterFormHandler(date, "transactionStartDate");
                  }}
                />
              </Col>
              <Col sm="6">
                <CustomDatePicker
                  placeHolder="To"
                  value={
                    filterForm?.transactionEndDate
                      ? moment(filterForm?.transactionEndDate)
                      : null
                  }
                  handler={(index, date, keyName) => {
                    filterFormHandler(date, "transactionEndDate");
                  }}
                  minDate={moment(filterForm?.transactionStartDate)}
                  disabled={!filterForm?.transactionStartDate}
                />
              </Col>
            </Row>
          </div>

          <div className="mt-3 d-flex flex-row-reverse justify-content-between">
            <AButton
              variant="primary_filled"
              className="w-full"
              onClick={handleApplyFilter}
              disabled={
                !filterForm.transactionTypeList.length &&
                !filterForm.businessAreaList.length &&
                !filterForm.transactionStartDate &&
                !filterForm.transactionEndDate
              }
            >
              Apply filter
            </AButton>

            {filterCount > 0 && (
              <AButton
                variant="outline"
                className="button_remove_left_margin"
                updatedStyle={{ border: "1px solid #CC5F5F", color: "#CC5F5F" }}
                onClick={() => {
                  closeForm();
                  // setFilte;
                  applyFilter(initialFilters);
                  setFilterCount(0);
                }}
              >
                Remove filter
              </AButton>
            )}
          </div>
        </div>
      </CardBody>
    </Card>
  );
};

export default BarcodeFilters;
